import React, { createContext } from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './components/App';
import reportWebVitals from './reportWebVitals';
import Colors from './ColorData.json';

export const ColorContext = createContext();

const index = Math.floor(Math.random() * Colors.length)
const color = Colors[index]

ReactDOM.render(
  <React.StrictMode>
    <ColorContext.Provider value={color}>
      <App />
    </ColorContext.Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
